import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { IPage } from '@/interfaces/page';
import { MenuGroupMember } from '@/resources/MenuGroupMember';
import { AppCollection } from '@/stores/AppStore';

export const FETCH_GROUP_MEMBERS_KEY = 'fetch-group-members';

export const fetchGroupMembers = (
  store: AppCollection,
  filters: Record<string, string>,
  options: {
    include: Array<string>;
    page?: IPage;
  }
) => {
  const { page, include } = options;

  // menu_group_id: menuGroupId,
  //   library: 'true',

  return store.fetchAll(MenuGroupMember, {
    include,
    filter: {
      ...omitBy(filters, isNil),
    },
    params: [
      {
        key: 'page[size]',
        value: page?.size?.toString() || '10',
      },
      {
        key: 'page[number]',
        value: page?.number?.toString() || '1',
      },
    ],
  });
};

export const FETCH_SINGLE_GROUP_MEMBERS_KEY = 'fetch-single-group-members';

export const fetchSingleGroupMembers = async (
  store: AppCollection,
  menuGroupId: string,
  options: {
    include: Array<string>;
  },
  pageSize = 2,
  pageNumber = 1
) => {
  const { include } = options;

  return store.fetchAll(MenuGroupMember, {
    include,
    filter: {
      menu_group_id: menuGroupId,
      library: 'true',
    },
    params: [
      {
        key: 'page[size]',
        value: pageSize.toString(),
      },
      {
        key: 'page[number]',
        value: pageNumber.toString(),
      },
    ],
  });
};
